<div class="verification-tractors-page">
    <div class="container">
        <div class="info-content">
            <div class="info">
                <div class="portalLogo"></div>
                <h3 class="my-5">Program Units Assigned to Your Business</h3>
                <self-ins-policies-and-request-page></self-ins-policies-and-request-page>
            </div>
            <div class="contacts">
                <p class="m-0">Contact us:</p>
                <div>
                    <a href="mailto:AFPsupport@mcgriff.com?subject={{user?.verificationInfo?.insuredName ? user?.verificationInfo?.insuredName : ''}}">
                        AFPsupport@mcgriff.com
                    </a>
                    <span></span>
                    <a href="tel:+18448186243">844-818-6243</a>
                </div>
            </div>
            <div class="footer mt-2">
                <a
                    href="https://www.marshmma.com/us/privacy-notice.html"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Privacy Notice
                </a>
            </div>
        </div>
        <div class="main-content">
            <div class="table-cont">
                <p class="m-0">Our data shows that the following program tractors are assigned to you</p>
                <div class="searchBar">
                    <input
                        id="search"
                        class="form-input"
                        placeholder="Search"
                        (keyup)="applyFilter()"
                        [(ngModel)]="gridFilterValue"
                    />
                    <label
                        for="search"
                        class="form_label"
                    >Search
                    </label>
                </div>
                <table mat-table matSort [dataSource]="tractors">
                    <ng-container matColumnDef="vin">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>VIN</th>
                        <td mat-cell *matCellDef="let element"> {{element.vin}} </td>
                    </ng-container>
                    <ng-container matColumnDef="year">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>Year</th>
                        <td mat-cell *matCellDef="let element"> {{element.year}} </td>
                    </ng-container>
                    <ng-container matColumnDef="make">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>Make</th>
                        <td mat-cell *matCellDef="let element"> {{element.make}} </td>
                    </ng-container>
                    <ng-container matColumnDef="equipmentId">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>Equipment Id</th>
                        <td mat-cell *matCellDef="let element"> {{element.equipmentId}} </td>
                    </ng-container>
                    <ng-container matColumnDef="fuelType">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>Fuel Type</th>
                        <td mat-cell *matCellDef="let element"> {{element.fuelType}} </td>
                    </ng-container>
                    <ng-container matColumnDef="pickupDate">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>Pickup Date</th>
                        <td mat-cell *matCellDef="let element"> {{element.pickupDate  | date: 'yyyy-MM-dd'}} </td>
                    </ng-container>
                    <ng-container matColumnDef="insuranceEffDate">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>Insurance Eff Date</th>
                        <td mat-cell *matCellDef="let element"> {{element.insuranceEffDate | date: 'yyyy-MM-dd'}} </td>
                    </ng-container>
                    <ng-container matColumnDef="insuranceTermDate">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>Insurance Term Date</th>
                        <td mat-cell *matCellDef="let element"> {{element.insuranceTermDate | date: 'yyyy-MM-dd'}} </td>
                    </ng-container>
                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef>Action</th>
                        <td mat-cell *matCellDef="let element">
                            <a *ngIf="element.allowDownload"
                                (click)="downloadIdCard(element)"
                                title="Download" class="mx-2">
                                <img src="../../../assets/download-icon.svg" width="15"
                                    alt="download-icon">
                            </a>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row class="table-row" *matRowDef="let row; columns: displayedColumns;"></tr>
                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell noData text-center" colspan="10">No data matching the filter <b>"{{gridFilterValue}}"</b></td>
                    </tr>
                </table>
                <div class="table-actions mt-2">
                    <p class="m-0">
                        <a href="mailto:AFPsupport@mcgriff.com?subject={{user?.verificationInfo?.insuredName ? user?.verificationInfo?.insuredName : ''}}">
                            Report
                        </a>
                        incorrect information
                    </p>
                    <div class="text-end" *ngIf="user?.status === 'active'">
                        <a (click)="downloadIdCards()" class="downloadAllPdf">
                            Download all ID Cards
                        </a>
                    </div>
                </div>
            </div>
            <div class="actions pt-3">
                <button class="primary-button"
                        [routerLink]="user?.status === 'active' ? ['/coverage'] : ['/verification']"
                        [queryParams]="user?.status === 'active' ? { qnum: qnum, qsuffix: qsuffix } : null">
                    Go back
                </button>
                <div *ngIf="!user || user.status !== 'active'">
                    <button (click)="onSubmit()" class="primary-button ms-3">
                        Continue
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
